import { render, staticRenderFns } from "./MyORESRedirectionLink.vue?vue&type=template&id=552e8a56"
import script from "./MyORESRedirectionLink.vue?vue&type=script&lang=ts"
export * from "./MyORESRedirectionLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports